import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NonUSFProductViewModel } from '../../models/non-usf-products-view-model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-non-usf-product-card-container',
  templateUrl: './non-usf-product-card-container.component.html',
  styleUrls: ['./non-usf-product-card-container.component.scss'],
})
export class NonUsfProductCardContainerComponent {
  @Input() productsData: NonUSFProductViewModel[];
  @Input() platform: PlatformEnum;
  @Output()
  selectEvent: EventEmitter<NonUSFProductViewModel> = new EventEmitter();
  @Output()
  nameClickEvent: EventEmitter<NonUSFProductViewModel> = new EventEmitter();
  constructor() {}

  handleSelect(event: NonUSFProductViewModel) {
    this.selectEvent.emit(event);
  }

  handleNameClick(event: NonUSFProductViewModel) {
    this.nameClickEvent.emit(event);
  }
}
